var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp_logo_text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 53.593,
    viewBox: "0 0 115 53.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M29.782,19.491a7.306,7.306,0,0,0,0,14.612l10.558,0v4.871H28.465a12.18,12.18,0,0,1,0-24.36H48.12c4.31,0,7.79-2.76,7.778-6.17V0H26.95A26.642,26.642,0,0,0,0,26.575,27.015,27.015,0,0,0,26.95,53.593H55.9V25.659c.012-3.41-3.468-6.168-7.778-6.168Z",
    fill: "#ed1c24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M114.093,33.529l13.213,20.063H109.141L96.3,34.106H90.08V53.592H73.841V25.659c-.014-3.408,3.468-6.168,7.778-6.168H107.21a2.437,2.437,0,0,0,0-4.874H81.619c-4.31,0-7.792-2.759-7.778-6.168V0h34.887a17.2,17.2,0,0,1,5.365,33.528Z",
    transform: "translate(-12.306 0)",
    fill: "#ed1c24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrLogo);
export default __webpack_public_path__ + "static/media/GRLogo.f79cd06cc3078ea1a81bc270c9e56f30.svg";
export { ForwardRef as ReactComponent };